import { map, Observable } from 'rxjs';
import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { Progress } from '../../models/progress/progress.model';

export const mapProgressBody =
    <Body, Type>(mapper: (input: Body) => Type) =>
    (source$: Observable<Progress<Body>>) =>
        source$.pipe(
            map((progress): Progress<Type> => {
                if (progress.type === ProgressTypeEnum.DONE) {
                    return {
                        ...progress,
                        data: mapper(progress.data),
                    };
                }

                return progress;
            }),
        );
